import React from 'react';
import TreeSelectCatalog from '../TreeSelect/TreeSelectCatalog';

export default function KatoTreeSelect(props) {
  return (
    <TreeSelectCatalog {...props} lookupId="60"/>
  )
}
